<template>
  <section class="buy-panel-size-selection">
    <form class="buy-panel-size-selection-form">
      <div
        ref="buyPanelFormContainer"
        class="buy-panel-size-selection-form-container"
      >
        <div
          v-for="(item, index) in itemsToPurchase"
          :key="index"
          class="buy-panel-size-selection-form-container-sizeqty"
        >
          <div
            v-if="showSizeDropdown"
            class="buy-panel-size-selection-form-container-sizeqty-wrapper size-select-wrapper"
          >
            <div
              class="buy-panel-size-selection-form-container-sizeqty-wrapper-ttl select-wrapper-text"
            >
              {{ translations.buyPanelSize }}
            </div>
            <a
              v-if="$props.showSizeGuide && index === 0"
              @click="openGuideSizeModal"
            >
              {{ translations.buyPanelSizeGuide }}
            </a>
            <select
              @change="onChangeSize($event.target.value, index)"
              v-model="item.size"
              :disabled="buyPanelIsLoading"
              name="buy-panel-size-selection-form-container-sizeqty-wrapper-select"
            >
              <option value="" selected>{{ translations.selectText }}</option>
              <option
                v-for="(value, indexForSizes) in (sizes.short_display_values || sizes.values)"
                :key="value"
                :value="sizes.identifier[indexForSizes]"
              >
                {{ value }}
              </option>
            </select>
          </div>
          <div
            v-if="!disableQuantity"
            class="buy-panel-size-selection-form-container-sizeqty-wrapper qty-select-wrapper"
          >
            <div
              v-if="isQuantityLabelHide && !isFavoritesOnly || !isQuantityLabelHide"
              class="buy-panel-size-selection-form-container-sizeqty-wrapper-ttl select-wrapper-text"
            >
              {{ translations.buyPanelQTY }}
            </div>
            <select
              v-if="isQuantitySelectHide && !isFavoritesOnly || !isQuantitySelectHide"
              @change="onChangeQuantity($event.target.value, index)"
              :disabled="buyPanelIsLoading"
              v-model="item.quantity"
              class="buy-panel-size-selection-form-container-sizeqty-wrapper-select"
            >
              <option
                v-for="indexForQuantity in maxQuantity"
                :key="indexForQuantity"
                :value="indexForQuantity"
              >
                {{ indexForQuantity }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>
<script>

import sizeSelection from '@/mixins/BuyPanel/SizeSelection';

export default {
  name: "sizeSelection",
  mixins: [
    sizeSelection
  ],
  props: {
    showSizeGuide: {
      type: Boolean,
      default: false
    },
    isQuantityLabelHide: {
      type: Boolean,
      default: false
    },
    isQuantitySelectHide: {
      type: Boolean,
      default: false
    },
    isFavoritesOnly: {
      type: Boolean,
      default: false
    },
    buyPanelIsLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'customizer'
    },
    disableQuantity: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    disableQuantity(newVal) {
      if (newVal == true) {
        this.$store.commit("buyPanel/SAVE_ITEM_QUANTITY", { index: 0, quantity: 1 });
      }
    }
  }
};
</script>
